<template>
  <header>
    <!-- Silence for now -->
  </header>
</template>
